<template>
  <PageContainer>
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-8">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, your past week of sleep</h2>
        <p>We'll help you improve your sleep with these scores 😎</p>
      </div>
      <div class="grid grid-cols-1 gap-4 mt-4">
        <!-- CONSISTENCY -->
        <div @click="infoConsistency = true" class="flex flex-row gap-4 items-center px-4 border-2 rounded-lg" :class="'border-' + sleepStore.summary.consistency.color + '-200'">
          <div class="relative inset-0">
            <MetricSleepConsistency
              :dateFrom='dateFrom'
              :dateTo='dateTo'
              :hideName='true'
              :small='true'
            />
          </div>
          <div class="flex flex-col text-left">
            <div class="text-lg"><span class="font-medium">Consistency</span> is <span class="font-medium" :class="'text-' + sleepStore.summary.consistency.color + '-400'">{{ sleepStore.summary.consistency.grade }}</span></div>
            <div>{{ sleepStore.summary.consistency.text }}</div>
          </div>
        </div>
        <!-- DURATION -->
        <div @click="infoDuration = true" class="flex flex-row gap-4 items-center px-4 border-2 rounded-lg" :class="'border-' + sleepStore.summary.duration.color + '-200'">
          <div class="relative inset-0">
            <MetricSleepDuration
              :dateFrom='dateFrom'
              :dateTo='dateTo'
              :hideName='true'
              :small='true'
            />
          </div>
          <div class="flex flex-col text-left">
            <div class="text-lg"><span class="font-medium">Duration</span> is <span class="font-medium" :class="'text-' + sleepStore.summary.duration.color + '-400'">{{ sleepStore.summary.duration.grade }}</span></div>
            <div>{{ sleepStore.summary.duration.text }}</div>
          </div>
        </div>
        <!-- QUALITY -->
        <div @click="infoQuality = true" class="flex flex-row gap-4 items-center px-4 border-2 rounded-lg" :class="'border-' + sleepStore.summary.quality.color + '-200'">
          <div class="relative inset-0">
            <MetricSleepQuality
              :dateFrom='dateFrom'
              :dateTo='dateTo'
              :hideName='true'
              :small='true'
            />
          </div>
          <div class="flex flex-col text-left">
            <div class="text-lg"><span class="font-medium">Quality</span> is <span class="font-medium" :class="'text-' + sleepStore.summary.quality.color + '-400'">{{ sleepStore.summary.quality.grade }}</span></div>
            <div>{{ sleepStore.summary.quality.text }}</div>
          </div>
        </div>
      </div>
      <button @click="goToNext()" class="mt-6">See how to improve →</button>
    </div>
  </PageContainer>

  <!-- MODALS -->
  <InformationConsistency
    v-if="infoConsistency"
    v-model="infoConsistency"
  />
  <InformationDuration
    v-if="infoDuration"
    v-model="infoDuration"
  />
  <InformationQuality
    v-if="infoQuality"
    v-model="infoQuality"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import PageContainer from '@/components/PageContainer'
import MetricSleepConsistency from '@/components/MetricSleepConsistency'
import MetricSleepDuration from '@/components/MetricSleepDuration'
import MetricSleepQuality from '@/components/MetricSleepQuality'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useSleepStore } from '@/stores/sleep'
import { get7DaysAgo } from '@/helpers/time'

export default {
  name: 'OnboardingInsights',
  components: {
    PageContainer,
    MetricSleepConsistency,
    MetricSleepDuration,
    MetricSleepQuality,
    InformationConsistency: defineAsyncComponent(
      () => import('@/components/modals/InformationConsistency'),
    ),
    InformationDuration: defineAsyncComponent(
      () => import('@/components/modals/InformationDuration'),
    ),
    InformationQuality: defineAsyncComponent(
      () => import('@/components/modals/InformationQuality'),
    ),
  },
  props: {
  },
  emits: [
  ],
  data() {
    const dates = get7DaysAgo()

    return {
      dateFrom: dates.start,
      dateTo: dates.end,
      infoConsistency: false,
      infoDuration: false,
      infoQuality: false,
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
    async goToNext() {
      // Create user's first plan.
      await this.userStore.user.startPlan()
      this.$router.push('/onboarding/plan')
    },
  },
  computed: {
    ...mapStores(useUserStore, useSleepStore),
  },
}
</script>